// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"4adf3114","329":"c3df31cc","337":"e4fc75a4","377":"dfebad4d","488":"9c92ff38","701":"0d7e788b","765":"0eb43b4f","785":"b6d08364","901":"6b87910b"}[chunkId] + ".chunk.js";
};